import { cloneDeep as _cloneDeep } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import QuestionResponse from './QuestionResponse';
import {
  findChoice,
  isSubmitted,
  buildSelectableChoices,
  organizeUserChoices,
  getChoicesFromProgress,
} from '../../helpers/questionHelper';

import RTEContent from '../../helpers/contentMathjaxHelper';

export default class QuestionSelfReflection extends Component {
  constructor(props) {
    super(props);

    this.state = this.buildState();
  }

  buildState = () => {
    const { questionProgress, question } = this.props;
    if (isSubmitted(questionProgress)) {
      const userChoices = getChoicesFromProgress(questionProgress, question);
      return {
        userChoices: organizeUserChoices(question, userChoices),
        questionState: 'no_answer',
        isSubmitted: true,
      };
    }
    const userChoices = buildSelectableChoices(question.choices);
    return {
      userChoices: organizeUserChoices(question, userChoices),
      questionState: 'initial',
    };
  };

  toggleUserChoice = userChoice => {
    this.setState(state => {
      const newUserChoices = _cloneDeep(state.userChoices);
      const newUserChoice = findChoice(userChoice, newUserChoices);
      newUserChoice.is_selected = !newUserChoice.is_selected;
      return { userChoices: newUserChoices };
    });
  };

  handleAnswerQuestion = () => {
    if (!this.isCurrentQuestionAnswered()) {
      return;
    }

    this.setState({ questionState: 'no_answer', isSubmitted: true });
    this.props.submitChoices(this.state.userChoices);
  };

  isCurrentQuestionAnswered = () => this.state.userChoices.some(choice => choice.is_selected === true);

  render() {
    const { question } = this.props;
    const { userChoices, isSubmitted } = this.state;

    return (
      <>
        <div className="content" style={{ paddingBottom: '0 !important' }}>
          <div className="questions" role="group" aria-live="polite">
            {userChoices.map((userChoice, index) => {
              const labelClass = classnames({
                'option-label': true,
                'option-label__active': userChoice.is_selected,
              });

              return (
                <div key={index} className={classnames('question', isSubmitted && 'question---disabled')}>
                  <input
                    id={`questions-${question.id}-${index}-multiple`}
                    onChange={() => this.toggleUserChoice(userChoice)}
                    type="checkbox"
                    checked={userChoice.is_selected}
                    disabled={isSubmitted}
                  />
                  <div className="option-label-wrapper">
                    <RTEContent
                      content={userChoice.prompt}
                      Tag="label"
                      htmlForVar={`questions-${question.id}-${index}-multiple`}
                      classSelector={labelClass}
                    />
                  </div>
                </div>
              );
            })}
          </div>

          <QuestionResponse
            question={this.props.question}
            questionState={this.state.questionState}
            handleAnswerQuestion={this.handleAnswerQuestion}
            isCurrentQuestionAnswered={this.isCurrentQuestionAnswered}
            renderNext={this.props.renderNext}
            renderQuestionsNavigation={this.props.renderQuestionsNavigation}
          />
        </div>
      </>
    );
  }
}

QuestionSelfReflection.propTypes = {
  question: PropTypes.object.isRequired,
  questionProgress: PropTypes.object,
  submitChoices: PropTypes.func.isRequired,
};
